import { Box, Flex, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useMemo, useState } from 'react';
import { checkSelectedActiveColumn } from '../../../utils/market-development';
import Spreadsheet from 'react-spreadsheet';
import ProvinceSpreadSheet from '../../../components/MarketDevelopment/Miscellaneous/spreadsheet-province-list';
import TotalSpreadSheet from '../../../components/MarketDevelopment/Miscellaneous/spreadsheet-total';
import { isNullOrBlank } from '../../../utils/checker';
import { toFormatCurrency } from '../../../utils/format';

export default function NatCateTable({ provinces = [], cells = [], numColumn = 9, onChange = (cells) => null }) {
	const { t } = useTranslation();
	const [active, setActive] = useState(null);
	const formattedCells = useMemo(
		() =>
			cells?.map((row) =>
				row?.map((col) => ({
					...col,
					value: (() => {
						if (false === isNullOrBlank(col?.value)) {
							return toFormatCurrency(col?.value, null);
						}
						return col?.value;
					})(),
				})),
			),
		[cells],
	);

	return (
		<>
			<Box className="natcat_container">
				<div className="natcat_label_head">{t('Province/City')}</div>
				<table className="spreadsheet_custom_header">
					<thead>
						<tr style={{ height: '34px' }}>
							<td colSpan="3" className="natcat_background_silver">
								<Tooltip label={t('Nat Cat')}>{t('Nat Cat')}</Tooltip>
							</td>
							<td colSpan="3" className="natcat_background_silver">
								<Tooltip label={t('Nat Cat for Property and Casualty')}>{t('Nat Cat for Property and Casualty')}</Tooltip>
							</td>
							<td colSpan="3" className="natcat_background_silver">
								<Tooltip label={t('Nat Cat for Agriculture')}>{t('Nat Cat for Agriculture')}</Tooltip>
							</td>
						</tr>
						<tr style={{ height: '34px' }}>
							<td
								className={
									checkSelectedActiveColumn(active, 0)
										? 'active-column singleLine smallFont'
										: 'natcat_background_silver singleLine smallFont'
								}
							>
								<Tooltip label={t('Gross Premium')}>{t('Gross Premium')}</Tooltip>
							</td>
							<td
								className={
									checkSelectedActiveColumn(active, 1)
										? 'active-column singleLine smallFont'
										: 'natcat_background_silver singleLine smallFont'
								}
							>
								<Tooltip label={t('Number of Policies')}>{t('Number of Policies')}</Tooltip>
							</td>
							<td
								className={
									checkSelectedActiveColumn(active, 2)
										? 'active-column singleLine smallFont'
										: 'natcat_background_silver singleLine smallFont'
								}
							>
								<Tooltip label={t('Sum Insured')}>{t('Sum Insured')}</Tooltip>
							</td>
							<td
								className={
									checkSelectedActiveColumn(active, 3)
										? 'active-column singleLine smallFont'
										: 'natcat_background_silver singleLine smallFont'
								}
							>
								<Tooltip label={t('Gross Premium')}>{t('Gross Premium')}</Tooltip>
							</td>
							<td
								className={
									checkSelectedActiveColumn(active, 4)
										? 'active-column singleLine smallFont'
										: 'natcat_background_silver singleLine smallFont'
								}
							>
								<Tooltip label={t('Number of Policies')}>{t('Number of Policies')}</Tooltip>
							</td>
							<td
								className={
									checkSelectedActiveColumn(active, 5)
										? 'active-column singleLine smallFont'
										: 'natcat_background_silver singleLine smallFont'
								}
							>
								<Tooltip label={t('Sum Insured')}>{t('Sum Insured')}</Tooltip>
							</td>
							<td
								className={
									checkSelectedActiveColumn(active, 6)
										? 'active-column singleLine smallFont'
										: 'natcat_background_silver singleLine smallFont'
								}
							>
								<Tooltip label={t('Gross Premium')}>{t('Gross Premium')}</Tooltip>
							</td>
							<td
								className={
									checkSelectedActiveColumn(active, 7)
										? 'active-column singleLine smallFont'
										: 'natcat_background_silver singleLine smallFont'
								}
							>
								<Tooltip label={t('Number of Policies')}>{t('Number of Policies')}</Tooltip>
							</td>
							<td
								className={
									checkSelectedActiveColumn(active, 8)
										? 'active-column singleLine smallFont'
										: 'natcat_background_silver singleLine smallFont'
								}
							>
								<Tooltip label={t('Sum Insured')}>{t('Sum Insured')}</Tooltip>
							</td>
						</tr>
					</thead>
				</table>
				<div>
					<Flex>
						<ProvinceSpreadSheet type="t1" label={null} labelMarginTop="0px" provinces={provinces} active={active} />
						<Box>
							<Flex alignItems="center" mt="0px" h="0px" borderRight="1px solid hsl(2deg, 0%, 91%)" pl={2} pr={2} />
							<Spreadsheet
								data={formattedCells}
								onChange={(el) => {
									let localData = el?.reduce((p, c) => {
										let lp = p;
										let lc = c?.slice(0, numColumn);
										lp.push(lc);
										return lp;
									}, []);
									localData = localData?.slice(0, provinces?.length);
									onChange(localData);
								}}
								onActivate={(e) => setActive({ ...e, t: 't1' })}
								hideRowIndicators
								hideColumnIndicators
							/>
						</Box>
					</Flex>
					<TotalSpreadSheet data={cells} numColumn={numColumn} />
				</div>
			</Box>
		</>
	);
}
